<form [name]="form" [formGroup]="form">
    <div fxLayoutAlign="center">
        <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Descripción del motivo</mat-label>
            <textarea matInput formControlName="observaciones" rows="7" placeholder="" maxlength="40000"></textarea>
        </mat-form-field>
    </div>
</form>